import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { useNavigate } from 'react-router-dom';
export function ModifyProfile() {
  const navigate = useNavigate();
  const enrolledCourses = [{
    name: 'Ethics & The Rules (with NAR Code of Ethics)',
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/23/2012'
  }, {
    name: "Don't Lose Your License",
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/11/2012'
  }, {
    name: 'The Owner Is In Default',
    status: '(Course enrolled)',
    creditType: '3 hrs. Legal Issues',
    created: '04/11/2012'
  }, {
    name: 'They Are A Protected Class',
    status: '(Course enrolled)',
    creditType: '3 hrs. Fair Housing',
    created: '04/11/2012'
  }, {
    name: 'A Letter From ADRE',
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/11/2012'
  }, {
    name: 'Are They Represented?',
    status: '(Section in progress)',
    creditType: '3 hrs. Agency Law',
    created: '04/11/2012'
  }, {
    name: 'Follow All The Laws',
    status: '(Course enrolled)',
    creditType: '3 hrs. Legal Issues',
    created: '04/11/2012'
  }, {
    name: 'No Secrets',
    status: '(Course enrolled)',
    creditType: '3 hrs. Disclosure',
    created: '04/11/2012'
  }, {
    name: 'Common Contract Issues',
    status: '(Section in progress)',
    creditType: '3 hrs. Contract Law',
    created: '04/11/2012'
  }];
  return <div className="space-y-6" data-id="element-1296" data-mp="3sjanyujawqmi">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1297" data-mp="3niwfjbdsfeny">Manage Profile</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1298" data-mp="3nl0seitnzo0d">
        {/* Left Column: Profile Fields */}
        <Card data-id="element-1299" data-mp="2fhmkuhtr7sq6">
          <CardHeader data-id="element-1300" data-mp="2jksnlfhnr1rw">
            <CardTitle data-id="element-1301" data-mp="2jlc8n52lu6a5">Profile Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4" data-id="element-1302" data-mp="25ljj3d2tdw3r">
            <Input label="Title" defaultValue="Mr" data-id="element-1303" data-mp="25krn415b1wcy" />
            <Input label="First Name" defaultValue="Admin" data-id="element-1304" data-mp="2ak4acn0395g2" />
            <Input label="Last Name" defaultValue="Admin" data-id="element-1305" data-mp="2aijg6yhoroiq" />
            <Input label="Company" defaultValue="Desert Sage Seminars" data-id="element-1306" data-mp="1vv80qlidvkdc" />
            <Input label="Address 1" defaultValue="15560 N. Frank Lloyd W" data-id="element-1307" data-mp="20ly8g5ea7zb7" />
            <Input label="Address 2" defaultValue="#B4-5185" data-id="element-1308" data-mp="20oaw8z6q13w6" />
            <Input label="City" defaultValue="Scottsdale" data-id="element-1309" data-mp="1mw34jluao34c" />
            <Select label="State/Province *" defaultValue="AZ" options={[{
            value: 'AZ',
            label: 'Arizona'
          }, {
            value: 'CA',
            label: 'California'
          }, {
            value: 'NV',
            label: 'Nevada'
          }]} data-id="element-1310" data-mp="1rtmtpgsj60b2" />
            <Input label="Zip" defaultValue="85260" data-id="element-1311" data-mp="ua4r6qzb77x5" />
            <Input label="Phone" defaultValue="602-377-6207" data-id="element-1312" data-mp="188cwpnaevhjx" />
            <Input label="Email" helperText="Leave blank to keep existing email (administration@desertsageseminars.com)" data-id="element-1313" data-mp="185qf0utt3lnz" />
            <Input label="Fax" data-id="element-1314" data-mp="1h7gdgkm3vkv9" />
            <Input label="How Did You Hear About Us" data-id="element-1315" data-mp="1h6erhl3jxdyr" />
            <Input label="Facebook" data-id="element-1316" data-mp="1d64kc540whib" />
            <Input label="Username" helperText="Leave blank to keep existing username (admin)" data-id="element-1317" data-mp="1d5383xb9toz0" />
            <Input type="password" label="Password" helperText="Leave blank to keep existing password" data-id="element-1318" data-mp="1lyzlammgjr2a" />

            <div className="py-2" data-id="element-1319" data-mp="20unxaxy0pigq">
              <a href="#" className="text-blue-600 hover:underline text-sm" data-id="element-1320" data-mp="1vy76fvzfopzy">
                Click here to obtain your license expiration date from ADRE
              </a>
            </div>

            <Input label="Available Courses" defaultValue="0" data-id="element-1321" data-mp="3uf7p1av80rt6" />

            <div className="pt-4" data-id="element-1322" data-mp="3udeevllefpgf">
              <Button data-id="element-1323" data-mp="313c34uzn6ai">Update</Button>
            </div>
          </CardContent>
        </Card>

        {/* Right Column: Course Assignments */}
        <div className="space-y-6" data-id="element-1324" data-mp="7ylcu7yuqf7f">
          <Card data-id="element-1325" data-mp="81qytec6p0yx">
            <CardContent className="space-y-4 pt-6" data-id="element-1326" data-mp="36hs7bup4etkv">
              <Select label="Course" options={[{
              value: '1',
              label: 'NAR Code of Ethics (NO CE CREDIT)'
            }, {
              value: '2',
              label: 'Ethics & The Rules (with NAR Code of Ethics)'
            }, {
              value: '3',
              label: 'Deeds, Fires & Water: Be Prepared'
            }, {
              value: '4',
              label: 'Are They Represented?'
            }, {
              value: '5',
              label: 'Mastering Agency Agreements'
            }, {
              value: '6',
              label: 'A Letter From ADRE'
            }, {
              value: '7',
              label: "Don't Lose Your License"
            }, {
              value: '8',
              label: 'BMC #1 AZ Residential-Statutes and Rules'
            }, {
              value: '9',
              label: 'BMC #2 AZ Residential-Broker Policies'
            }, {
              value: '10',
              label: 'BMC #3 AZ Residential-Broker Supervision'
            }, {
              value: '11',
              label: 'BMC #3B Property Management'
            }, {
              value: '12',
              label: 'What Goes Wrong In Contracts'
            }, {
              value: '13',
              label: 'Avoid The Oops: Contract Smarts for Agents'
            }, {
              value: '14',
              label: 'No Secrets'
            }, {
              value: '15',
              label: 'The Bottom Line of Disclosure'
            }, {
              value: '16',
              label: 'Your Clients Are Not Mushrooms'
            }, {
              value: '17',
              label: 'They Are A Protected Class'
            }, {
              value: '18',
              label: "Fair Housing In Today's World"
            }, {
              value: '19',
              label: 'Accidental Property Management'
            }, {
              value: '20',
              label: 'Follow All The Laws'
            }]} data-id="element-1327" data-mp="36jd13i3m28ho" />
              <Select label="Statuses" defaultValue="enrolled" options={[{
              value: 'completed',
              label: 'Course Completed'
            }, {
              value: 'in_progress',
              label: 'Course in Progress'
            }, {
              value: 'emailed',
              label: 'Certificate Emailed'
            }, {
              value: 'enrolled',
              label: 'Course Enrolled'
            }, {
              value: 'section_progress',
              label: 'Section in Progress'
            }]} data-id="element-1328" data-mp="35rv4uzcaniin" />
              <Button className="w-full gap-2" data-id="element-1329" data-mp="2f89q7tugy8nk">
                <Plus className="h-4 w-4" data-id="element-1330" data-mp="2k5088mpu3ebm" />
                Add
              </Button>
            </CardContent>
          </Card>

          <Card data-id="element-1331" data-mp="2o6c1r3btwjp3">
            <CardHeader data-id="element-1332" data-mp="2o5sfxbj25b5s">
              <CardTitle data-id="element-1333" data-mp="2t66r32fyh181">Enrolled Courses</CardTitle>
            </CardHeader>
            <div className="overflow-x-auto" data-id="element-1334" data-mp="2t7hrcsa6zque">
              <table className="w-full text-sm text-left" data-id="element-1335" data-mp="2y5t53e3lylhw">
                <thead className="bg-slate-800 text-white font-medium border-b border-slate-700" data-id="element-1336" data-mp="2y36x5dct23z5">
                  <tr data-id="element-1337" data-mp="3329qi0jfalra">
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-1338" data-mp="37vcoqlz5ajdt">
                      Course Name
                    </th>
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-1339" data-mp="3bvmtxwf455rm">
                      Credit Type
                    </th>
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-1340" data-mp="3gxlukyjgxokv">
                      Created
                    </th>
                    <th className="px-4 py-3" data-id="element-1341" data-mp="3vysroikho7bo">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200" data-id="element-1342" data-mp="3qzzbujhqc48c">
                  {enrolledCourses.map((course, index) => <tr key={index} className="hover:bg-slate-50" data-id="element-1343" data-mp="3lzuwiwsk5fjp" data-mpi={index}>
                      <td className="px-4 py-3 border-r border-slate-200" data-id="element-1344" data-mp="3hz1882b7dyqa">
                        <div className="text-slate-900" data-id="element-1345" data-mp="3i1477buc3275">{course.name}</div>
                        <div className="text-slate-500 text-xs mt-0.5" data-id="element-1346" data-mp="iil3wnwdrpxn">
                          {course.status}
                        </div>
                      </td>
                      <td className="px-4 py-3 border-r border-slate-200 text-slate-700" data-id="element-1347" data-mp="8tb8ay2bvp4s">
                        {course.creditType}
                      </td>
                      <td className="px-4 py-3 border-r border-slate-200 text-slate-700" data-id="element-1348" data-mp="4qonhh42r4h3">
                        {course.created}
                      </td>
                      <td className="px-4 py-3" data-id="element-1349" data-mp="wivs1j6b2qf4">
                        <div className="flex items-center gap-2 text-sm" data-id="element-1350" data-mp="2pdu2l7v3qza9">
                          <button className="text-blue-600 hover:underline" onClick={() => navigate(`/profile/course-status/edit/${index}`)} data-id="element-1351" data-mp="2pe3q8osocucs">
                            Edit
                          </button>
                          <span className="text-slate-300" data-id="element-1352" data-mp="38bwkz3t59xz3">|</span>
                          <button className="text-red-600 hover:underline" data-id="element-1353" data-mp="38ad71juynz0h">
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}